import React from "react"
import { useState } from "react";
import TestingEnvironment from "./TestingEnvironment";

export default function UserConfiguration() {
    const [contactId, setContactId] = useState("");
    const [searchId, setSearchId] = useState(0);
    const handleInput = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setContactId(event.target.value);
    }

    const handleSubmit = (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        setSearchId(Number(contactId));
    }
    return (
        <div>
            <h2>User Configuration</h2>
            <div className="contactid-form">
                <form onSubmit={handleSubmit}>
                    <label>ContactId
                        <input 
                            type="text"
                            value={contactId}
                            onChange={handleInput}>
                        </input>
                    </label>
                    <input type="submit" value="Search Contact" />
                </form>
                {searchId !== 0 && <TestingEnvironment searchId={searchId} /> }
            </div>
        </div>
    )
}